import {
  IModel,
  Model,
  ClientDocumentRequestCommunicationTypeListingModel,
} from '@common/models';
import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { StorageContentModel } from './StorageContentModel';
import { DateTimeUtils } from '@common/utils';

export interface IClientDocumentRequestModel extends IModel {
  clientDocumentRequestId: number;
  documentRequestStatusId: number;
  storageContentId: number | undefined;
  storeId: number;
  clientId: number;
  petId: number | undefined;
  startDate: DateTime | undefined;
  endDate: DateTime | undefined;
  emailAddress: string;
  documentRequestStatusName: string;
  petName: string | undefined;
  clientName: string;
  userRequested: string;
  userId: number;
  storageContent: StorageContentModel | undefined;
  documentRequests:
    | ClientDocumentRequestCommunicationTypeListingModel[]
    | undefined;
  storeName: string;
  clientEmailAddress: string | undefined;
  dateCreated: DateTime | undefined;
}

export class ClientDocumentRequestModel
  extends Model
  implements IClientDocumentRequestModel
{
  clientDocumentRequestId: number;
  documentRequestStatusId: number;
  storageContentId: number | undefined;
  storeId: number;
  clientId: number;
  petId: number | undefined;
  startDate: DateTime | undefined;
  endDate: DateTime | undefined;
  emailAddress: string;
  documentRequestStatusName: string;
  petName: string | undefined;
  clientName: string;
  userRequested: string;
  userId: number;
  storageContent: StorageContentModel | undefined;
  documentRequests:
    | ClientDocumentRequestCommunicationTypeListingModel[]
    | undefined;
  storeName: string;
  clientEmailAddress: string | undefined;
  dateCreated: DateTime | undefined;

  constructor(params: IClientDocumentRequestModel) {
    super(params);
    this.clientDocumentRequestId = defaultTo(params.clientDocumentRequestId, 0);
    this.documentRequestStatusId = defaultTo(params.documentRequestStatusId, 0);
    this.storageContentId = defaultTo(params.storageContentId, undefined);
    this.storeId = defaultTo(params.storeId, 0);
    this.clientId = defaultTo(params.clientId, 0);
    this.petId = defaultTo(params.petId, undefined);
    this.emailAddress = defaultTo(params.emailAddress, '');
    this.documentRequestStatusName = defaultTo(
      params.documentRequestStatusName,
      '',
    );
    this.petName = defaultTo(params.petName, '');
    this.clientName = defaultTo(params.clientName, '');
    this.userRequested = defaultTo(params.userRequested, '');
    this.storageContent = params?.storageContent
      ? new StorageContentModel(params.storageContent)
      : undefined;
    this.userId = defaultTo(params.userId, 0);
    this.documentRequests = params?.documentRequests
      ? params.documentRequests
      : undefined;
    this.userId = defaultTo(params.userId, 0);
    this.storeName = defaultTo(params.storeName, '');
    this.clientEmailAddress = defaultTo(params.clientEmailAddress, undefined);
    this.dateCreated = DateTimeUtils.getAsDateTimeUTC(params.dateCreated)!;
  }
}
